const detectAppUtils = async (extensionId = '', callbackFunc) => {
  const newElementScript = document.createElement('script');
  newElementScript.onerror = () => callbackFunc(false);
  newElementScript.onload = () => callbackFunc(true);
  document.body.appendChild(newElementScript);
  const urlSrc = `chrome-extension://${extensionId}/manifest.json`;
  newElementScript.src = urlSrc;
};

export { detectAppUtils };
